import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=0206a34a&scoped=true&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"
import style1 from "./PageError.vue?vue&type=style&index=1&id=0206a34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206a34a",
  null
  
)

export default component.exports